import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '../utils/cn';

export const AdvanceReceipt = (
	props: React.ComponentPropsWithoutRef<'svg'>,
) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="AdvanceReceiptIcon"
			width="161"
			height="160"
			viewBox="0 0 161 160"
			fill="none"
			{...props}
		>
			<path
				d="M38.6414 40.5557C38.6415 35.6069 42.3971 31.5363 47.2136 31.0361V30.9834H103.858C113.523 30.9834 121.358 38.8184 121.358 48.4834V124.871L115.181 132.265L109.996 127.544L105.942 132.262L100.87 127.542L96.7029 132.26L91.7439 127.54L87.4646 132.258L82.6189 127.538L78.2263 132.257L73.4939 127.538L68.988 132.257L64.3679 127.537L59.7498 132.257L52.7869 124.966V94.2646H38.6414V40.5557ZM43.6414 89.2646H52.7869V40.5557C52.7867 38.0304 50.7389 35.9834 48.2136 35.9834C45.6885 35.9836 43.6416 38.0306 43.6414 40.5557V89.2646ZM57.7869 122.962L59.7937 125.063L64.3679 120.391L68.9431 125.062L73.406 120.39L78.0925 125.062L82.4441 120.39L87.2419 125.062L91.4822 120.388L96.3904 125.06L100.52 120.386L105.54 125.058L109.557 120.384L114.688 125.055L116.358 123.058V48.4834C116.358 41.5798 110.762 35.9834 103.858 35.9834H56.6257C57.3658 37.342 57.7868 38.8997 57.7869 40.5557V122.962Z"
				fill="#0770E4"
			/>
			<path
				d="M64.2275 49.0023C64.2275 47.6883 65.1884 46.623 66.3737 46.623H107.581C108.766 46.623 109.727 47.6883 109.727 49.0023C109.727 50.3164 108.766 51.3817 107.581 51.3817H66.3737C65.1884 51.3817 64.2275 50.3164 64.2275 49.0023Z"
				fill="#FC790D"
			/>
			<path
				d="M64.2275 60.6627C64.2275 59.3487 65.1884 58.2834 66.3737 58.2834H107.581C108.766 58.2834 109.727 59.3487 109.727 60.6627C109.727 61.9768 108.766 63.042 107.581 63.042H66.3737C65.1884 63.042 64.2275 61.9768 64.2275 60.6627Z"
				fill="#FC790D"
			/>
			<path
				d="M66.3737 69.7694C65.1884 69.7694 64.2275 70.8347 64.2275 72.1487C64.2275 73.4628 65.1884 74.528 66.3737 74.528H96.4205C97.6058 74.528 98.5667 73.4628 98.5667 72.1487C98.5667 70.8347 97.6058 69.7694 96.4205 69.7694H66.3737Z"
				fill="#FC790D"
			/>
			<path
				d="M66.256 80.9102C65.1347 80.9102 64.2275 81.8271 64.2275 82.9558C64.2275 84.0845 65.1347 85.0014 66.256 85.0014H75.8651L76.0895 85.359C77.1052 86.9779 77.7588 88.3736 78.1494 89.5684L78.4801 90.5797H66.256C65.1347 90.5797 64.2275 91.4966 64.2275 92.6253C64.2275 93.754 65.1347 94.6709 66.256 94.6709H78.4612L77.0311 96.0062C75.313 97.6103 72.4455 98.464 69.9557 98.7256C68.9906 98.827 68.4239 99.4211 68.2121 100.134C67.991 100.878 68.1661 101.721 68.7102 102.27L79.499 113.156C80.2913 113.955 81.5763 113.955 82.3685 113.156C83.1602 112.357 83.1602 111.063 82.3685 110.264L74.2401 102.062L75.3565 101.645C77.3404 100.904 79.2741 99.7694 80.6712 98.0685C81.3622 97.2272 81.9018 96.2697 82.2492 95.2006L82.4213 94.6709H87.3395C88.4609 94.6709 89.368 93.754 89.368 92.6253C89.368 91.4966 88.4609 90.5797 87.3395 90.5797H82.5739L82.4491 89.9645C82.2023 88.748 81.7664 87.4618 81.1292 86.1003L80.6149 85.0014H87.3395C88.4609 85.0014 89.368 84.0845 89.368 82.9558C89.368 81.8271 88.4609 80.9102 87.3395 80.9102H66.256Z"
				fill="#FC790D"
			/>
		</SvgIcon>
	);
};

export default AdvanceReceipt;
